// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.VoidPaymentRequest */
/* istanbul ignore next */
@GandalfModel
export class VoidPaymentRequest extends GandalfModelBase {

	@GandalfLabel('Refund Reason')
	@GandalfValidator({ notNull: { message: 'Refund Reason is required' } })
	@GandalfValidator({ sizeString: { message: 'Refund Reason must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	comments!: string;

	@GandalfLabel('Payment')
	@GandalfValidator({ notNull: { message: 'Payment is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	paymentId!: number;

	@GandalfLabel('Payment Transaction')
	@GandalfProperty({ designType: Number })
	paymentTransactionId!: number | null;

}
